export const hotWorks = [
  {
    id: 0,
    url: "/gjxx/tag3/",
    text: "建筑工程",
  },
  {
    id: 1,
    url: "/gjxx/tag8/",
    text: "市政工程",
  },
  {
    id: 2,
    url: "/gjxx/tag5/",
    text: "给排水",
  },
  {
    id: 3,
    url: "/gjxx/tag6/",
    text: "钢结构",
  },
  {
    id: 4,
    url: "/gjxx/tag96/",
    text: "园林",
  },
  {
    id: 5,
    url: "/gjxx/tag14/",
    text: "中央空调",
  },
  {
    id: 6,
    url: "/gjxx/tag69/",
    text: "路灯护栏",
  },
  {
    id: 7,
    url: "/gjxx/tag4/",
    text: "防水工程",
  },
  {
    id: 8,
    url: "/gjxx/tag106/",
    text: "广告牌",
  },
  {
    id: 9,
    url: "/gjxx/tag191/",
    text: "配电",
  },
  {
    id: 10,
    url: "/gjxx/tag94/",
    text: "绿化",
  },
  {
    id: 11,
    url: "/gjxx/tag3/",
    text: "交通运输",
  },
  {
    id: 12,
    url: "/gjxx/tag150/",
    text: "色谱仪",
  },
  {
    id: 13,
    url: "/gjxx/tag180/",
    text: "水利工程",
  },
  {
    id: 14,
    url: "/gjxx/tag283/",
    text: "办公家具",
  },
  {
    id: 15,
    url: "/gjxx/tag68/",
    text: "道路标志",
  },
  {
    id: 16,
    url: "/gjxx/tag117/",
    text: "医疗设备",
  },
  {
    id: 17,
    url: "/gjxx/tag247/",
    text: "系统集成",
  },
  {
    id: 18,
    url: "/gjxx/tag245/",
    text: "弱电工程",
  },
  {
    id: 19,
    url: "/gjxx/tag101/",
    text: "垃圾处理",
  },
  {
    id: 20,
    url: "/gjxx/tag187/",
    text: "电力设备",
  },
  {
    id: 21,
    url: "/gjxx/tag105/",
    text: "喷泉",
  },
  {
    id: 22,
    url: "/gjxx/tag2/",
    text: "房屋建筑",
  },
  {
    id: 23,
    url: "/gjxx/tag248/",
    text: "安防监控",
  },
];
export const industryBiddingData = [
  {
    id: 0,
    url: "/zb/hy_46",
    text: "机械设备加工",
  },
  {
    id: 1,
    url: "/zb/hy_45",
    text: "交通运输",
  },
  {
    id: 2,
    url: "/zb/hy_57",
    text: "出版印刷包装",
  },
  {
    id: 3,
    url: "/zb/hy_64",
    text: "安全防护",
  },
  {
    id: 4,
    url: "/zb/hy_52",
    text: "建筑水利桥梁",
  },
  {
    id: 5,
    url: "/zb/hy_48",
    text: "化工能源",
  },
  {
    id: 6,
    url: "/zb/hy_47",
    text: "电子电器",
  },
  {
    id: 7,
    url: "/zb/hy_54",
    text: "医疗卫生",
  },
  {
    id: 8,
    url: "/zb/hy_51",
    text: "通讯通信",
  },
  {
    id: 9,
    url: "/zb/hy_50",
    text: "计算机网络",
  },
  {
    id: 10,
    url: "/zb/hy_53",
    text: "环护绿化园林",
  },
  {
    id: 11,
    url: "/zb/hy_61",
    text: "商业服务",
  },
  {
    id: 12,
    url: "/zb/hy_49",
    text: "冶金矿产",
  },
  {
    id: 13,
    url: "/zb/hy_55",
    text: "科教办公",
  },
  {
    id: 14,
    url: "/zb/hy_67",
    text: "仪器仪表",
  },
  {
    id: 15,
    url: "/zb/hy_68",
    text: "艺术相关",
  },
  {
    id: 16,
    url: "/zb/hy_60",
    text: "农林渔牧",
  },
  {
    id: 17,
    url: "/zb/hy_58",
    text: "轻工业纺织食品",
  },
  {
    id: 18,
    url: "/zb/hy_56",
    text: "旅游运动娱乐",
  },
  {
    id: 19,
    url: "/zb/hy_63",
    text: "其他行业",
  },
];
export const substation = [
  {
    id: 0,
    area: "华北",
    city: [
      {
        id: 0,
        url: "/zb/area_2/",
        text: "北京",
      },
      {
        id: 1,
        url: "/zb/area_26/",
        text: "天津",
      },
      {
        id: 2,
        url: "/zb/area_9/",
        text: "河北",
      },
      {
        id: 3,
        url: "/zb/area_22/",
        text: "山西",
      },
      {
        id: 4,
        url: "/zb/area_18/",
        text: "内蒙古",
      },
    ],
  },
  {
    id: 1,
    area: "华中",
    city: [
      {
        id: 0,
        url: "/zb/area_10/",
        text: "河南",
      },
      {
        id: 1,
        url: "/zb/area_12/",
        text: "湖北",
      },
      {
        id: 2,
        url: "/zb/area_13/",
        text: "湖南",
      },
      {
        id: 3,
        url: "/zb/area_16/",
        text: "江西",
      },
    ],
  },
  {
    id: 2,
    area: "华南",
    city: [
      {
        id: 0,
        url: "/zb/area_5/",
        text: "广东",
      },
      {
        id: 1,
        url: "/zb/area_6/",
        text: "广西",
      },
      {
        id: 2,
        url: "/zb/area_8/",
        text: "海南",
      },
    ],
  },
  {
    id: 3,
    area: "东北",
    city: [
      {
        id: 0,
        url: "/zb/area_14/",
        text: "吉林",
      },
      {
        id: 1,
        url: "/zb/area_17/",
        text: "辽宁",
      },
      {
        id: 2,
        url: "/zb/area_11/",
        text: "黑龙江",
      },
    ],
  },
  {
    id: 4,
    area: "西北",
    city: [
      {
        id: 0,
        url: "/zb/area_23/",
        text: "陕西",
      },
      {
        id: 1,
        url: "/zb/area_4/",
        text: "甘肃",
      },
      {
        id: 2,
        url: "/zb/area_19/",
        text: "宁夏",
      },
      {
        id: 3,
        url: "/zb/area_20",
        text: "青海",
      },
      {
        id: 4,
        url: "/zb/area_28/",
        text: "新疆",
      },
    ],
  },
  {
    id: 5,
    area: "华东",
    city: [
      {
        id: 0,
        url: "/zb/area_21/",
        text: "山东",
      },
      {
        id: 1,
        url: "/zb/area_1/",
        text: "安徽",
      },
      {
        id: 2,
        url: "/zb/area_24/",
        text: "上海",
      },
      {
        id: 3,
        url: "/zb/area_15/",
        text: "江苏",
      },
      {
        id: 4,
        url: "/zb/area_30/",
        text: "浙江",
      },
      {
        id: 5,
        url: "/zb/area_3/",
        text: "福建",
      },
    ],
  },
  {
    id: 6,
    area: "西南",
    city: [
      {
        id: 0,
        url: "/zb/area_29/",
        text: "云南",
      },
      {
        id: 1,
        url: "/zb/area_7/",
        text: "贵州",
      },
      {
        id: 2,
        url: "/zb/area_25/",
        text: "四川",
      },
      {
        id: 3,
        url: "/zb/area_31/",
        text: "重庆",
      },
      {
        id: 4,
        url: "/zb/area_27/",
        text: "西藏",
      },
    ],
  },
];
